jQuery(document).ready(function ($) {
	Fancybox.bind('[data-fancybox]');
});
